module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-left.c5290081.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Tabs/images/tab-left.png
// module id = 3241
// module chunks = 11